import { render, staticRenderFns } from "./LoadingAddProduct.vue?vue&type=template&id=1dda3c1e&"
import script from "./LoadingAddProduct.vue?vue&type=script&lang=js&"
export * from "./LoadingAddProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports